module.exports = __webpack_public_path__ + "static/media/location-m.91b9cd2a.svg";